module.exports = "/images/qizhi_b625e6.png";